/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUnitsNotConfiguredForOvertimeReports} from '../api'

 export const useQueryGetUnitsNotConfiguredForOvertimeReports = createReactQueryHook('getUnitsNotConfiguredForOvertimeReports', getUnitsNotConfiguredForOvertimeReports)
